<template>
  <div style="height: 100%;">
    <div style="font-size: 18px; color: white; font-family: 黑体; font-weight: bold; margin-left: 10px;">各区巡检表</div>
    <div id="leftThree" style="height: 280px; display: flex; flex-wrap: nowrap;padding-right: 20px; margin-top: 5px; margin-left: 20px; width: 95%;overflow-y: scroll;overflow-x: scroll">
      <table align="center" style="font-size: 14px;height: 250px">
        <tr v-for="item1 in datas" style="color: white;">
          <td nowrap="nowrap" style="border-right: 1px solid rgba(255,255,255, 0.5)">{{item1[0]}}&nbsp;&nbsp;</td>
          <td v-for="item in item1[1]" style="padding-left:25px;border-right: 1px solid rgba(255,255,255, 0.1)">{{item}}</td>
        </tr>
        <tr style="color: white">
          <td>月份:</td>
          <td v-for="item in 12" style="padding-left:8px" nowrap="nowrap">{{item}}月</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeleftThree',
  props: ['areaId'],
  data(){
    return {
      months: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      areas: [],

      datas:[],
      // 获取各区巡检表
      AreaInspectSta:{
        "version": 1,
        "method": "synthScreen.AreaInspectSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      midDate:[],

      interval: null, // 轮询
    }
  },
  methods:{
    getAreaInspectSta(){
      this.AreaInspectSta.token = this.$store.state.token;
      console.log('获取各区巡检表');
      console.log(this.AreaInspectSta);
      this.$axios.post(this.$newMainUrl, this.AreaInspectSta).then(res=> {
        // this.$message({
        //   type:'success',
        //   message:'刷新'
        // })
        console.log('获取各区巡检表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.midDate = res.data.result.inspectStatus;
          this.areas = [];
          let cityNumber = Object.keys(this.midDate).sort();
          for(let i = 0;i<cityNumber.length;i++){
            this.areas.push(cityNumber[i])
          }
          console.log("本次输出区域为:"+this.areas)
          let keys = Object.keys(this.midDate);
          let values = this.midDate
          let Ydata = [];

          Ydata.length = 0; // datas 归零
         for(let i = 1;i<=keys.length;i++){
           let t = [];
           let tt = [];
            t.push(keys[i-1]);
            values[keys[i-1]].forEach(item2 =>{
              tt.push(item2)
            })
            // for(let j = 0;i<values[keys[i]].length;j++){
            //   tt.push(values[keys[i]][j]);
            // }
            // tt.push(values[keys[i]]);
            t.push(tt);
            Ydata.push(t);
            for(let i=0;i<Ydata.length;i++){
              for(let j=0;j<cityNumber.length;j++){
                if(Ydata[i][0] == cityNumber[j]){
                  Ydata[i][0] = cityNumber[j];
                }
              }
            }
           this.datas = Ydata;
          }

          // for(let i = 0;i<Object.keys(this.midDate).length;i++){
          //   let t = [];
          //   t.push(i);
          //   let tt = [];
          //
          //   // for(let key in this.midDate){
          //   //   tt.push(this.midDate[key])
          //   tt.push();
          //   t.push(tt);
          //   this.datas.push(t);
          // }



          // this.midDate.map((item, index) =>{
          //   let t = [];
          //   t.push(index);
          //   let tt = [];
          //   for(let key in item){
          //     if(item[key] instanceof Array){
          //       item[key].forEach(item2 =>{
          //         tt.push(item2);
          //       })
          //     }
          //   }
          //   t.push(tt);
          //   this.datas.push(t);
          // })
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    },
  },
  mounted () {

    this.getAreaInspectSta();

    this.interval = setInterval(()=>{
      this.getAreaInspectSta();
    }, 3000);

  },
  destroyed () {
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message:'结束'
    // })
  }
}
</script>

<style scoped>

</style>
<style lang="scss">
  /*#NotYLabel::-webkit-scrollbar*/
  /*{*/
  /*  width: 50px;*/
  /*  height: 16px;*/
  /*  !*background-color: red;*!*/
  /*}*/
  /*#NotYLabel::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*/
  /*  border-radius: 10px;*/
  /*  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
  /*  background: #1f53c1;*/
  /*}*/
  /*#NotYLabel::-webkit-scrollbar-track {!*滚动条里面轨道*!*/
  /*  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*/
  /*  border-radius: 10px;*/
  /*  background: rgba(255,255,255,0.1);*/
  /*}*/
  /*!*#NotYLabel::-webkit-scrollbar-thumb {!*滚动条里面小方块*!*!*/
  /*!*border-radius: 10px;*!*/
  /*!*-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);*!*/
  /*!*background: #535353;*!*/
  /*!*}*!*/
</style>
